/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable global-require */
var Icons = {
    appQrCode: require("../assets/img/apple-qr-code-square 1.svg"),
    appStore: require("../assets/img/apple 1.svg"),
    arrow: require("../assets/icons/Path 660.svg"),
    arrowRight: require("../assets/icons/arrow.svg"),
    blueTriangle: require('../assets/icons/blueTriangle.svg'),
    box: require('../assets/icons/Path 1047.svg'),
    check: require('../assets/icons/check-square.svg'),
    clear: require('../assets/icons/clear.svg'),
    closeIcon: require("../assets/icons/close icon.svg"),
    flag_cs: require("../assets/icons/flag_cs.svg"),
    flag_de: require("../assets/icons/flag_de.svg"),
    flag_en: require("../assets/icons/flag_en.svg"),
    flag_es: require("../assets/icons/flag_es.svg"),
    flag_fr: require("../assets/icons/flag_fr.svg"),
    flag_it: require("../assets/icons/flag_it.svg"),
    flag_pl: require("../assets/icons/flag_pl.svg"),
    flag_pt: require("../assets/icons/flag_pt.svg"),
    flag_sk: require("../assets/icons/flag_sk.svg"),
    flag_sl: require("../assets/icons/flag_sl.svg"),
    flag_uk: require("../assets/icons/flag_uk.svg"),
    g_bg_grey: require('../assets/icons/G-bg-grey.svg'),
    g_bg_white: require('../assets/icons/G-bg-white.svg'),
    googlePlay: require("../assets/img/google 1.svg"),
    googleQrCode: require("../assets/img/google-qr-code-square 1.svg"),
    iconMap: require("../assets/icons/Icon feather-map-pin.svg"),
    logoGA24: require('../assets/icons/logogad24.svg'),
    logoGad: require('../assets/img/logo gad.svg'),
    nA: require('../assets/icons/A.svg'),
    selectArrow: require("../assets/icons/selectArrow.svg"),
    transparent: require("../assets/icons/transparent 1.svg"),
    arrowPrev: require('../assets/icons/arrowPrev.svg'),
    arrowPrevInactive: require('../assets/icons/arrowPrevInactive.svg'),
    arrowNextInactive: require('../assets/icons/arrowNextInactive.svg'),
    arrowNext: require('../assets/icons/arrowNext.svg'),
};
export default Icons;
